import type { CommunicationEventData } from '@shared/types';

export interface TalkrouteCommunicationEventRecord {
  collection: 'phoneCalls' | 'textMessages';
  id: string;
  event: CommunicationEventData;
}

export const normalizeTalkroutePhoneNumber = (
  phoneNumber: string,
): string | undefined => {
  const digits = phoneNumber.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
  if (digits.length === 10) return digits;
  return undefined;
};

export const normalizeTalkroutePhoneNumbers = (
  phoneNumbers: string[],
): string[] => [
  ...new Set(
    phoneNumbers.flatMap(
      (phoneNumber) => normalizeTalkroutePhoneNumber(phoneNumber) ?? [],
    ),
  ),
];

export const isAssignableTalkrouteCommunicationEvent = (
  event: CommunicationEventData,
  normalizedPhoneNumbers: Set<string>,
): boolean => {
  const matchedPhoneNumber = normalizeTalkroutePhoneNumber(
    event.talkroutePhoneNumber,
  );
  return (
    event.source === 'talkroute' &&
    matchedPhoneNumber !== undefined &&
    normalizedPhoneNumbers.has(matchedPhoneNumber) &&
    !event.user &&
    !event.timeEntry
  );
};

export const getTalkrouteCommunicationAssignmentCandidates = (
  records: TalkrouteCommunicationEventRecord[],
  phoneNumbers: string[],
): TalkrouteCommunicationEventRecord[] => {
  const normalizedPhoneNumbers = new Set(
    normalizeTalkroutePhoneNumbers(phoneNumbers),
  );
  return records.filter((record) =>
    isAssignableTalkrouteCommunicationEvent(
      record.event,
      normalizedPhoneNumbers,
    ),
  );
};
